import { render, staticRenderFns } from "./panel_addPet.vue?vue&type=template&id=af8f15fc&scoped=true&"
import script from "./panel_addPet.vue?vue&type=script&lang=js&"
export * from "./panel_addPet.vue?vue&type=script&lang=js&"
import style0 from "./panel_addPet.vue?vue&type=style&index=0&id=af8f15fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8f15fc",
  null
  
)

export default component.exports